import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getSiteVisitProjects(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/site-visit-project?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


async function createSiteVisitProject(payload, isFormData = false) {
  let config = {
    headers: {
      Authorization: 'Bearer ' + user.token,
    },
  };

  if (isFormData) {
    // config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  try {
    const { data: response } = await axios.post(`${endpoint}/site-visit-project`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


export { getSiteVisitProjects , createSiteVisitProject};
